import { useEffect, useState } from "react";
import { AdminApp } from "./web-admin/AdminApp";
import { MobileApp } from "./mobile-app/MobileApp";

type Surface = "admin" | "mobile";

function readSurface(): Surface {
  if (typeof window === "undefined") return "admin";
  return window.location.pathname.startsWith("/m") ? "mobile" : "admin";
}

export function App() {
  const [surface, setSurface] = useState<Surface>(readSurface);

  useEffect(() => {
    const onPop = () => setSurface(readSurface());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return surface === "mobile" ? <MobileApp /> : <AdminApp />;
}
